import { Box, Flex, Grid, Heading, Text } from "@radix-ui/themes";
import { HeroStyle2 } from "~/components/HeroStyle2";
import { HomeConsultForm } from "~/components/home/HomeConsultForm";
import {
	Locale,
	useLocalization,
} from "~/components/localization/LocalizationProvider";
import { OptimizedImage } from "~/components/OptimizedImage";
import { Link } from "~/components/RouterLink";
import styles from "../live-seo-page.module.css";

type MiamiBracesLocalization = {
	heroTitle: string;
	introHeading: string;
	introCopy: string;
	optionsHeading: string;
	optionsIntroBefore: string;
	optionsIntroLink: string;
	optionsIntroAfter: string;
	metalHeading: string;
	metalFirst: string;
	metalSecond: string;
	clearHeading: string;
	clearBefore: string;
	clearLink: string;
	clearAfter: string;
	clearSecond: string;
	clearThird: string;
	trustedHeading: string;
	trustedBeforeHome: string;
	trustedHomeLink: string;
	trustedMiddle: string;
	trustedConsultLink: string;
	trustedAfter: string;
};

const miamiBracesLocalization = {
	[Locale.EN]: {
		heroTitle: "Miami Braces",
		introHeading: "Miami Braces Expert",
		introCopy:
			"If you're looking for someone you can trust to provide a brilliant straight smile in the Miami, WA area, the team at Miami Orthodontic Specialists are here for you. We proudly create beautiful new smiles for patients of all ages in Miami, and surrounding communities. We're proud to offer patients various orthodontic options, including traditional metal braces and ceramic braces. Traditional braces are one of the most effective tools we have for achieving optimal tooth and jaw alignment.",
		optionsHeading: "Miami Braces Options",
		optionsIntroBefore: "Most patients we treat choose ",
		optionsIntroLink: "traditional metal braces",
		optionsIntroAfter:
			" to straighten their teeth. While metal braces are the most common type of orthodontic treatment, you have several other options, including clear braces. Traditional braces have stood the test of time thanks to their strength, durability, and affordability. This is a big part of why they've withstood the test of time and are still the top orthodontic treatment year after year.",
		metalHeading: "Metal Braces",
		metalFirst:
			"Metal braces have had a reputation for being awkward and obvious. Still, because of modern orthodontics, you will benefit from versions that are smaller, less conspicuous, and more comfortable than ever before.",
		metalSecond:
			"Metal braces are cost-effective because they don't require some more complex technology or expensive equipment that newer treatments do. The strength, durability, and affordability of traditional metal braces keep them the top treatment for orthodontic patients, year after year!",
		clearHeading: "Clear Braces",
		clearBefore: "Our ",
		clearLink: "clear braces",
		clearAfter:
			" are designed to be less noticeable on your teeth than metal braces. They're smaller than ever and made of nearly invisible tooth-colored polycrystalline ceramic material.",
		clearSecond:
			"We think ceramic braces are better suited to adults and older teens. This is because ceramic brackets are more likely to break, and they're more expensive than metal brackets.",
		clearThird:
			"No matter what kind of traditional braces you choose, conventional braces, you can often see visible signs of improvement relatively quickly, which can help increase your confidence in both your smile and the orthodontic process!",
		trustedHeading:
			"Miami Orthodontic Specialists is Your Trusted Braces Expert",
		trustedBeforeHome:
			"Using our leading-edge techniques and state-of-the-art technology, we will provide efficient, comfortable care that will help you change your smile and your life! At ",
		trustedHomeLink: "Miami Ortho Specialists",
		trustedMiddle:
			" , we believe that advanced, personalized care leads to the best results and most positive orthodontic experience. Dr. Leavitt and the rest of our skilled team focus on patients as individuals, no matter the age, personal concerns, or clinical needs. When you choose braces treatment with our practice, We will create a treatment plan that works with all parts of your life. ",
		trustedConsultLink: "Schedule a free consultation",
		trustedAfter: " with us today to get started!",
	},
	[Locale.ES]: {
		heroTitle: "Brackets en Miami",
		introHeading: "Expertos en brackets en Miami",
		introCopy:
			"Si buscas a alguien de confianza para ayudarte a lograr una sonrisa recta y brillante en el área de Miami, el equipo de Miami Orthodontic Specialists está aquí para ti. Creamos sonrisas hermosas para pacientes de todas las edades en Miami y las comunidades cercanas. Nos enorgullece ofrecer varias opciones de ortodoncia, incluidos brackets metálicos tradicionales y brackets cerámicos. Los brackets tradicionales son una de las herramientas más eficaces que tenemos para lograr una alineación óptima de los dientes y la mandíbula.",
		optionsHeading: "Opciones de brackets en Miami",
		optionsIntroBefore: "La mayoría de los pacientes que tratamos eligen ",
		optionsIntroLink: "brackets metálicos tradicionales",
		optionsIntroAfter:
			" para enderezar sus dientes. Aunque los brackets metálicos son el tipo más común de tratamiento de ortodoncia, tienes varias otras opciones, incluidos los brackets transparentes. Los brackets tradicionales han resistido el paso del tiempo gracias a su fuerza, durabilidad y precio accesible. Esa es una gran parte de por qué siguen siendo el tratamiento de ortodoncia más elegido año tras año.",
		metalHeading: "Brackets metálicos",
		metalFirst:
			"Los brackets metálicos han tenido fama de ser incómodos y muy visibles. Sin embargo, gracias a la ortodoncia moderna, ahora puedes beneficiarte de versiones más pequeñas, menos notorias y más cómodas que nunca.",
		metalSecond:
			"Los brackets metálicos son económicos porque no requieren algunas de las tecnologías más complejas o equipos costosos que usan tratamientos más nuevos. La fuerza, durabilidad y accesibilidad de los brackets metálicos tradicionales los mantienen como el tratamiento principal para pacientes de ortodoncia año tras año.",
		clearHeading: "Brackets transparentes",
		clearBefore: "Nuestros ",
		clearLink: "brackets transparentes",
		clearAfter:
			" están diseñados para ser menos visibles en tus dientes que los brackets metálicos. Son más pequeños que nunca y están hechos de un material cerámico policristalino casi invisible del color del diente.",
		clearSecond:
			"Creemos que los brackets cerámicos son más adecuados para adultos y adolescentes mayores. Esto se debe a que los brackets cerámicos tienen más probabilidades de romperse y son más costosos que los brackets metálicos.",
		clearThird:
			"Sin importar qué tipo de brackets tradicionales elijas, a menudo puedes ver señales visibles de mejora relativamente rápido, lo que puede aumentar tu confianza tanto en tu sonrisa como en el proceso de ortodoncia.",
		trustedHeading:
			"Miami Orthodontic Specialists es tu experto de confianza en brackets",
		trustedBeforeHome:
			"Con nuestras técnicas avanzadas y tecnología de vanguardia, brindamos atención eficiente y cómoda para ayudarte a cambiar tu sonrisa y tu vida. En ",
		trustedHomeLink: "Miami Ortho Specialists",
		trustedMiddle:
			" creemos que la atención avanzada y personalizada produce los mejores resultados y la experiencia de ortodoncia más positiva. La Dra. Leavitt y el resto de nuestro equipo experto se enfocan en cada paciente como individuo, sin importar su edad, inquietudes personales o necesidades clínicas. Cuando eliges tratamiento con brackets en nuestra práctica, crearemos un plan de tratamiento que funcione con todas las partes de tu vida. ",
		trustedConsultLink: "Programa una consulta gratuita",
		trustedAfter: " con nosotros hoy para comenzar.",
	},
} satisfies Record<Locale, MiamiBracesLocalization>;

export function MiamiBracesPage() {
	const getLocalization = useLocalization(miamiBracesLocalization);

	return (
		<Flex direction="column">
			<HeroStyle2
				heroImageUrl="/smile-best-medicine.png"
				title={getLocalization("heroTitle")}
				backgroundPosition="top"
			/>
			<article className={styles.miamiBracesBand}>
				<Box className={styles.miamiBracesInner}>
					<Grid className={styles.miamiBracesTwoColumn}>
						<Box className={styles.miamiBracesSmallColumn}>
							<OptimizedImage
								alt="Miami Braces"
								className={styles.miamiBracesImage}
								height={533}
								src="/smile-best-medicine.png"
								width={1000}
							/>
						</Box>
						<Box className={styles.miamiBracesSmallColumn}>
							<Heading as="h2" className={styles.miamiBracesSectionHeading}>
								{getLocalization("introHeading")}
							</Heading>
							<Text as="p" className={styles.miamiBracesCopy}>
								{getLocalization("introCopy")}
							</Text>
						</Box>
					</Grid>
					<Grid className={styles.miamiBracesTwoColumn}>
						<Box className={styles.miamiBracesSmallColumn}>
							<Heading as="h3" className={styles.miamiBracesSubheading}>
								{getLocalization("optionsHeading")}
							</Heading>
							<Text as="p" className={styles.miamiBracesCopy}>
								{getLocalization("optionsIntroBefore")}
								<Link to="/metal-braces" className={styles.inlineLink}>
									{getLocalization("optionsIntroLink")}
								</Link>
								{getLocalization("optionsIntroAfter")}
							</Text>
							<Text as="p" className={styles.miamiBracesCopy}>
								<strong>{getLocalization("metalHeading")}</strong>
								<br />
								{getLocalization("metalFirst")}
							</Text>
							<Text as="p" className={styles.miamiBracesCopy}>
								{getLocalization("metalSecond")}
							</Text>
						</Box>
						<Box className={styles.miamiBracesSmallColumn}>
							<OptimizedImage
								alt="Miami Orthodontics"
								className={styles.miamiBracesImage}
								height={1324}
								src="/watermark_24-10-2018_01-16-14PM.jpg"
								width={2000}
							/>
						</Box>
					</Grid>
					<Box className={styles.miamiBracesFullColumn}>
						<Text as="p" className={styles.miamiBracesCopy}>
							<strong>{getLocalization("clearHeading")}</strong>
							<br />
							{getLocalization("clearBefore")}
							<Link to="/clear-braces" className={styles.inlineLink}>
								{getLocalization("clearLink")}
							</Link>
							{getLocalization("clearAfter")}
						</Text>
						<Text as="p" className={styles.miamiBracesCopy}>
							{getLocalization("clearSecond")}
						</Text>
						<Text as="p" className={styles.miamiBracesCopy}>
							{getLocalization("clearThird")}
						</Text>
						<Heading as="h3" className={styles.miamiBracesSubheading}>
							{getLocalization("trustedHeading")}
						</Heading>
						<Text as="p" className={styles.miamiBracesCopy}>
							{getLocalization("trustedBeforeHome")}
							<Link to="/" className={styles.inlineLink}>
								{getLocalization("trustedHomeLink")}
							</Link>
							{getLocalization("trustedMiddle")}
							<Link to="/free-consult" className={styles.inlineLink}>
								{getLocalization("trustedConsultLink")}
							</Link>
							{getLocalization("trustedAfter")}
						</Text>
					</Box>
				</Box>
			</article>
			<Box className={styles.formWrap}>
				<HomeConsultForm />
			</Box>
		</Flex>
	);
}
